export default "__VITE_ASSET__0UqBIcRs__"